import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import translate from '../translate';
import PromoDateBox from './PromoDateBox';
import { formatDateTime } from '../../services/utilityFunctions';

const PromoDates = props => {
  const { createPromoDateTime, promotionPriceDateStart, promotionPriceDateEnd } = props;
  const currentDate = moment().utc().valueOf();
  const hasPromotionDate =
    (promotionPriceDateStart && !promotionPriceDateEnd) ||
    (promotionPriceDateStart && promotionPriceDateEnd && promotionPriceDateStart < promotionPriceDateEnd) ||
    (!promotionPriceDateStart && promotionPriceDateEnd && promotionPriceDateEnd > currentDate);
  return (
    <>
      <div className="row">
        <div className="col-form-label col-lg-3 col-12 text-right" />
        <div className="col-lg-6 col-12 row promoDatesWrapper">
          {createPromoDateTime('promotionPriceDateStart', 'promoStartDateWrapper')}
          {createPromoDateTime('promotionPriceDateEnd', 'promoEndDateWrapper')}
          <input
            type="hidden"
            id="promotionCurrentTime"
            value={formatDateTime(moment().utc().valueOf(), 'DD MMMM YYYY - HH:mm')}
          />
        </div>
      </div>
      {hasPromotionDate && (
        <div className="row promoMessageWrapper">
          <div className="col-form-label col-3 text-right" />
          <div className="col-5">
            <PromoDateBox
              promotionPriceDateStart={promotionPriceDateStart}
              promotionPriceDateEnd={promotionPriceDateEnd}
            />
          </div>
        </div>
      )}
    </>
  );
};

PromoDates.propTypes = {
  createPromoDateTime: PropTypes.func.isRequired,
  promotionPriceDateStart: PropTypes.number,
  promotionPriceDateEnd: PropTypes.number,
};
PromoDates.defaultProps = {
  promotionPriceDateStart: null,
  promotionPriceDateEnd: null,
};

export default translate(PromoDates);
